import { RefinementBar } from "./RefinementBar";
import { FacetValueTagsComponent } from "../facetvaluetags/FacetValueTagsComponent";
import {
  NextBestActionComponent,
  registerNextBestAction,
  registerNextBestActionComponentHandlers,
} from "../nextBestAction/NextBestActionComponent";
import { isActive, isNotActive } from "../toggle/Toggle";
import { events } from "../events";
import { heureka } from "@otto-ec/heureka";
import { registerFilterPersonalizationEventHandlers } from "../filterPersonalization/filterPersonalization";

export function registerRefinementBar() {
  if (isActive("HEUREKA_2117_MOUNT_NBF_DIRECTLY_IN_REFINEMENT_BAR")) {
    registerNextBestAction();
    registerFilterPersonalizationEventHandlers();
  } else {
    registerNextBestActionComponentHandlers();
  }
  if (isActive("HEUREKA_2135_MOVE_ELEMENTS_TO_REFINEMENT_BAR")) {
    registerRefinementBarInit();
  } else {
    registerRefinementBarInitDeprecated();
  }
  registerRefinementBarLocking();
  if (isNotActive("HEUREKA_2117_MOUNT_NBF_DIRECTLY_IN_REFINEMENT_BAR")) {
    registerFacetValueTagsInit();
    registerNextBestActionInit();
  }
}

function registerRefinementBarInitDeprecated() {
  events.onFilterSectionLoaded(RefinementBar.initAllDeprecated);
  heureka.refinementBar_update.on(RefinementBar.initAllDeprecated);
}

function registerRefinementBarInit() {
  events.onFilterSectionLoaded(RefinementBar.initAll);
}

function registerRefinementBarLocking() {
  /*      */
  events.onFilterSectionLoad(RefinementBar.lockAll);
  /*        */
  events.onRefinementBarLoaded(RefinementBar.unlockAll);
}

function registerFacetValueTagsInit() {
  if (NextBestActionComponent.isNotVisible()) {
    events.onFilterSectionLoaded(FacetValueTagsComponent.initAll);
  }
}

function registerNextBestActionInit() {
  if (NextBestActionComponent.couldBeVisible()) {
    events.onFilterSectionLoaded(NextBestActionComponent.initAll);
  }
}
